<h4 class="mb-4">{{ orderSummaryData['orderOverview'] }}</h4>

<div [formGroup]="offerSummaryFormGroup">
  <div [ngClass]="class" *ngIf="plan$ | async as plan">
    <div class="{{ class + '__plan text-medium' }}">
      <div class="flex justify-content-between mb-2">
        <h4>Gewähltes Paket</h4>
        <p class="text-medium">Preis/Monat</p>
      </div>
      <div class="flex justify-content-between mb-2">
        <p class="text-dark-grey text-medium">
          {{ plan.planType }}
        </p>
        <p class="flex-shrink-0 text-medium">{{ plan.price | euroCurrency }}</p>
      </div>
      <p class="mb-2 pb-1 text-dark-grey-2 {{ class }}__basic-module">
        Grundmodul
        <span class="text-primary-color">{{ plan.planType | basicModuleText }}</span>
      </p>

      <div [ngClass]="class + '__addons'">
        <div *ngFor="let module of plan.additionalModules">
          <div
            *ngIf="planCalculatorService.getModuleCalculatedPrice(module.price, module.name, plan.workStationCount, plan.planType)"
            class="flex justify-content-between"
          >
            <p class="text-dark-grey text-medium mb-2">
              {{ module.name }}
            </p>
            <p *ngIf="module" class="text-medium">
              {{
                planCalculatorService.getModuleCalculatedPrice(module.price, module.name, plan.workStationCount, plan.planType)
                  | euroCurrency
              }}
            </p>
          </div>
        </div>
      </div>
      <div *ngIf="plan.cloudVersion" class="flex justify-content-between mb-2">
        <p class="text-medium">
          <span>Cloud Version</span>
        </p>
        <p class="text-medium">+{{ planCalculatorService.getCloudVersionCost(plan.cloudVersion, plan.workStationCount) | euroCurrency }}</p>
      </div>
      <div *ngIf="plan.devicesCount" class="flex justify-content-between mb-2">
        <p class="text-medium">
          <span class="text-primary-color text-bold">{{ plan.devicesCount }}</span>
          {{ plan.devicesCount | pluralize : 'device' }}
        </p>
        <p class="text-medium">+{{ planCalculatorService.getTotalDeviceCost(plan.devicesCount) | euroCurrency }}</p>
      </div>

      <div *ngIf="plan.clientsCount" class="flex justify-content-between mb-2">
        <p class="text-medium">
          <span class="text-primary-color text-bold">{{ plan.clientsCount }}</span>
          {{ plan.clientsCount | pluralize : 'client' }}
        </p>
        <p class="text-medium">{{ planCalculatorService.getClientsCost(plan.clientsCount) | euroCurrency }}</p>
      </div>

      <div *ngIf="plan.workStationCount" class="flex justify-content-between">
        <p class="text-medium">
          <span class="text-primary-color text-bold">{{ plan.workStationCount }}</span>
          {{ plan.workStationCount | pluralize : 'workStation' }}
        </p>
        <p class="text-medium">{{ planCalculatorService.getTotalWorkStationCostWithModule(plan) | euroCurrency }}</p>
      </div>
    </div>
    <div class="{{ class + '__subtotal mb-4' }}">
      <div class="flex justify-content-between">
        <p class="">{{ orderSummaryData['subtotalTitle'] }}</p>
        <p class="text-medium">
          {{ planCalculatorService.getSubtotal(plan) | euroCurrency }}
        </p>
      </div>
    </div>

    <div class="{{ class + '__checkbox mb-4' }}">
      <p-checkbox
        binary="true"
        inputId="binary"
        [(ngModel)]="hasOldPlanVersion"
        [ngModelOptions]="{ standalone: true }"
        (onChange)="hasOldPlanChckBxChange($event)"
      ></p-checkbox>
      <p for="terms" class="{{ class + '__checkbox-text text-medium' }}">Vorherige Version</p>
    </div>

    <ng-container *ngIf="hasOldPlanVersion">
      <div>
        <label class="required">Vorherige Version</label>
        <p-dropdown
          [options]="oldPlanVersionSelect"
          optionLabel="name"
          [showClear]="true"
          placeholder=""
          class="mb-2"
          [(ngModel)]="selectedPlanVersion"
          [ngModelOptions]="{ standalone: true }"
          (onChange)="oldPlanVersionChange()"
        >
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2">
              <span class="text-medium">{{ selectedPlanVersion.name }}</span>
              <ng-container *ngIf="selectedPlanVersion.id != 1">- {{ selectedPlanVersion.version }}</ng-container>
            </div>
          </ng-template>
          <ng-template let-planVersion pTemplate="item">
            <div class="flex align-items-center gap-2">
              <p>
                <span class="text-medium">{{ planVersion.name }}</span>
                <ng-container *ngIf="planVersion.id != 1">- {{ planVersion.version }}</ng-container>
              </p>
            </div>
          </ng-template>
        </p-dropdown>
        <!-- <span class="small-text text-highlight" *ngIf="contactForm.get('salutation')?.invalid && contactForm.get('salutation')?.touched">
              {{ getErrorMessage('salutation', 'Anrede') }}
            </span> -->
      </div>

      <div class="{{ class + '__subtotal mb-3 mt-2' }}">
        <div class="flex justify-content-between" *ngIf="(oldPlanDiscount ?? 0) > 0">
          <p class="text-primary-color">Sonderrabatt {{ oldPlanDiscount }}%</p>
          <p class="text-medium text-primary-color">
            {{ planCalculatorService.getSubtotal(plan) * ((oldPlanDiscount ?? 0) / 100) | euroCurrency }}
          </p>
        </div>
      </div>
    </ng-container>

    <div class="mb-5">
      <div class="flex justify-content-between mb-1">
        <h4>{{ orderSummaryData['totalTitle'] }}</h4>
        <h4>{{ planCalculatorService.getNewPlanTotal(plan, oldPlanDiscount ?? 0) | euroCurrency }}</h4>
      </div>
      <p *ngIf="showOldDiscountNote" class="small-text text-dark-grey-2">Gilt für mindestens 12 Monate ab Umstellungsdatum.</p>
      <p class="small-text text-dark-grey-2">Alle genannten Preise gelten zuzüglich MwSt.</p>
    </div>
  </div>

  <div [ngClass]="class + '__field'">
    <label for="comment">Zusätzliche Bemerkungen</label>

    <textarea
      id="comment"
      pInputTextarea
      formControlName="comment"
      rows="6"
      maxlength="500"
      placeholder="Vermerke zusätzliche Informationen oder Anforderungen..."
    ></textarea>

    <div class="char-counter">{{ offerSummaryFormGroup.get('comment')?.value?.length || 0 }}/500</div>
  </div>
</div>
